
// 여기 설명 잘 되어 있음 : https://vuex.vuejs.org/kr/guide/modules.html

import {menuList, menuMap} from '../menus'

const state = {
  menuList,
  menuMap,
  dev_status: {},
  help_status: {},
}

const getters = {
  menuList : s => s.menuList,
  menuMap : s => s.menuMap,
  // name : (state, getters, rootState, rootGetters) => {
  menu : (state, getters, rootState) => {
    const path = rootState.route.path
    const menu = state.menuMap[path] || {}
    return menu
    // return `${ menu.parentName } / ${ menu.name }`
  },
  devStatus : (state) => state.dev_status,
  helpStatus : (state) => state.help_status,
}

const mutations = {
  setDevStatus : (state,t) => state.dev_status = t,
  setDevStatusOne : (state, t) => state.dev_status[t.path] = t.status,

  setHelpStatus : (state,t) => state.help_status = t,
  setHelpStatusOne : (state, t) => state.help_status[t.path] = t.status
}

const actions = {
  loadDevStatus(context) { // context, payload
    this._vm.$ui.httpGet('/proc/N_DEV_COMMENT_STATUS_LOAD', null,
      ret => {context.commit('setDevStatus', ret.data.rs1.reduce((m,i) => {
            m[i.path] = i.status
            return m
          }, {})
        )
        // console.log(state.dev_status);
      }
    )
  },
  loadHelpStatus(context) { // context, payload
    this._vm.$ui.httpGet('/proc/N_HELP_COMMENT_STATUS_LOAD', null,
      ret => {context.commit('setHelpStatus', ret.data.rs1.reduce((m,i) => {
            m[i.path] = i.status
            return m
          }, {})
        )
      }
    )
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
